import { INVALID_MAJOR_ID } from '../constants/invalidMajorId';
import type { IStudentMajors } from '../operations/query/students/useGetStudentMajors';

export const popInvalidMajors = (majors: IStudentMajors[]): IStudentMajors[] =>
  majors.filter((major) => major.tblMajor?.id !== INVALID_MAJOR_ID);
